var map = {
	"./sticky-bg-brush.svg": 710,
	"./sticky-bg-clock.svg": 711,
	"./sticky-bg-euro.svg": 712,
	"./sticky-bg-lock.svg": 713,
	"./sticky-bg-shield.svg": 714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 709;